import { useEffect } from "react";
import { useScene } from "./SceneController";

const ScrollController = () => {
    const { updateScene } = useScene();

    useEffect(() => {
        const sections = [
            "hero",
            "problem",
            "control",
            "solution",
            "transformation",
            "vision",
            "cta",
        ];

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    updateScene({ section: entry.target.id });
                });
            },
            { threshold: 0.55 },
        );

        sections.forEach((id) => {
            const el = document.getElementById(id);

            if (el) observer.observe(el);
        });

        return () => observer.disconnect();
    }, [updateScene]);

    return null;
};

export default ScrollController;
